import PaymentHistoryPage from "../components/paymentHistory/main";

const PaymentHistory = () => {
  return <PaymentHistoryPage />;
};

export default PaymentHistory;
